import {SelectedAccount, TraderDBAccount} from '@qep/types/src/index';

export const traderDbAccountToSelectedAccount = (account: TraderDBAccount): SelectedAccount => {
  const accountSelect: SelectedAccount = {
    account,
    memo: account.memo,
    tradeIntention: account.tradeIntentions[0],
    customText2: account.customText2,
    customText3: account.customText3,
  };
  return (accountSelect);
};

export const accounttoAccountSelectorValue = (account: TraderDBAccount): SelectedAccount => {
  const accountSelect: SelectedAccount = {
    account,
    memo: account.memo,
    tradeIntention: account.tradeIntentions[0],
    customText2: account.customText2,
    customText3: account.customText3,
  };
  return (accountSelect);
};
